export { default as af } from './af'
export { default as ar } from './ar'
export { default as bg } from './bg'
export { default as ca } from './ca'
export { default as ckb } from './ckb'
export { default as cs } from './cs'
export { default as da } from './da'
export { default as de } from './de'
export { default as el } from './el'
export { default as en } from './en'
export { default as es } from './es'
export { default as et } from './et'
export { default as fa } from './fa'
export { default as fi } from './fi'
export { default as fr } from './fr'
export { default as hr } from './hr'
export { default as hu } from './hu'
export { default as he } from './he'
export { default as id } from './id'
export { default as it } from './it'
export { default as ja } from './ja'
export { default as ko } from './ko'
export { default as lv } from './lv'
export { default as lt } from './lt'
export { default as nl } from './nl'
export { default as no } from './no'
export { default as pl } from './pl'
export { default as pt } from './pt'
export { default as ro } from './ro'
export { default as ru } from './ru'
export { default as sk } from './sk'
export { default as sl } from './sl'
export { default as srCyrl } from './sr-Cyrl'
export { default as srLatn } from './sr-Latn'
export { default as sv } from './sv'
export { default as th } from './th'
export { default as tr } from './tr'
export { default as az } from './az'
export { default as uk } from './uk'
export { default as vi } from './vi'
export { default as zhHans } from './zh-Hans'
export { default as zhHant } from './zh-Hant'

export const defaultRtl = {
  af: false,
  ar: true,
  bg: false,
  ca: false,
  ckb: false,
  cs: false,
  de: false,
  el: false,
  en: false,
  es: false,
  et: false,
  fa: false,
  fi: false,
  fr: false,
  hr: false,
  hu: false,
  he: true,
  id: false,
  it: false,
  ja: false,
  ko: false,
  lv: false,
  lt: false,
  nl: false,
  no: false,
  pl: false,
  pt: false,
  ro: false,
  ru: false,
  sk: false,
  sl: false,
  srCyrl: false,
  srLatn: false,
  sv: false,
  th: false,
  tr: false,
  az: false,
  uk: false,
  vi: false,
  zhHans: false,
  zhHant: false,
}
